import {seamlessBootstrap, seamlessImmutable} from 'epic-alt-utils/index';

import AppConfigActions from '../actions/AppConfigActions';
import AppConfigSource from '../sources/AppConfigSource';
import Immutable from 'seamless-immutable';
import alt from '../alt';
import {datasource} from 'alt-utils/lib/decorators';
import root from 'window-or-global';

@datasource(AppConfigSource)
@seamlessImmutable
class AppConfigStore {
    getStateFunctions() {
        return {
            getDownloadUrl() {
                if (root._epicGamesNav && root._epicGamesNav.browser && root._epicGamesNav.browser.mac) {
                    return this.macDownloadUrl;
                }
                return this.pcDownloadUrl;
            },
            checkGameLaunched() {
                const isAvailable = {launched: false, info: {}};
                const crtCountry = this.country;
                const launchedCountries = this.launchedCountries && this.launchedCountries.asMutable({
                    deep: true
                });
                const launcherCountriesInfo = launchedCountries && launchedCountries.countryLaunchedInfo || [];
                if (launcherCountriesInfo) {
                    for (const country of launcherCountriesInfo) {
                        if (crtCountry === country.countryCode) {
                            isAvailable.launched = true;
                            isAvailable.info = country;
                        }
                    }
                }
                return isAvailable;
            }
        };
    }

    constructor() {
        this.on('error', (error) => {console.error(error);});
        this.on('bootstrap', seamlessBootstrap.bind(this, null));
        const initialState = Immutable({
            pcDownloadUrl: null,
            macDownloadUrl: null,
            motdSlug: null,
            isPrerender: false,
            euCookieMessage: {},
            country: '',
            globalAlert: null,
            launchedCountries: {},
            unavailableCountries: {}
        });
        this.state = initialState.merge(this.getStateFunctions());
        this.bindActions(AppConfigActions);
    }
}

export default alt.createStore(AppConfigStore, 'AppConfigStore');
